import { ISubscriptionRepository } from "@/domain/repositories/subscription.repository";
import { SubscriptionValidator } from "@/domain/entities-new/subscription/subscription.validations";

import APIClient from "@/infrastructure/api/client";
import { repositoryNetworkErrorHandler } from "@/infrastructure/repositories/common/repository-error-handler";
import { ok, safeTry } from "@/lib/result-pattern";
import { repositoryCreateCheckoutSessionHandler } from "@/domain/errors/subscription";

const SubscriptionApiRepository: ISubscriptionRepository = {
  async getSubscriptions() {
    const result = await safeTry(async () => {
      return await APIClient.get("/subscriptions/");
    }, repositoryNetworkErrorHandler);

    if (!result.ok) {
      return result;
    }

    return SubscriptionValidator.Subscription.Array.fromAPI(result.value.data);
  },
  async createCheckoutSession(type) {
    const result = await safeTry(
      async () => {
        return await APIClient.get(
          `/subscriptions/stripe/checkout/?type=${encodeURIComponent(type)}`
        );
      },
      (error) => {
        return repositoryNetworkErrorHandler(error, {
          customAxiosErrorHandler: repositoryCreateCheckoutSessionHandler,
        });
      }
    );

    if (!result.ok) {
      return result;
    }

    return SubscriptionValidator.CheckoutSession.fromAPI(result.value.data);
  },

  async createBillingPortalSession() {
    const result = await safeTry(async () => {
      return await APIClient.get("/subscriptions/stripe/billing-portal/");
    }, repositoryNetworkErrorHandler);

    if (!result.ok) {
      return result;
    }

    return SubscriptionValidator.BillingPortalSession.fromAPI(
      result.value.data
    );
  },

  async cancelSubscription() {
    const result = await safeTry(async () => {
      return await APIClient.post("/subscriptions/cancellations/");
    }, repositoryNetworkErrorHandler);

    if (!result.ok) {
      return result;
    }

    return ok(void 0);
  },
  async getLatestInvoice() {
    const result = await safeTry(
      () => APIClient.get("/invoices/"),
      repositoryNetworkErrorHandler
    );

    if (!result.ok) {
      return result;
    }

    const data = result.value.data as { status: string }[];

    const latestPaid = data.find((inv) => inv.status === "paid");

    if (!latestPaid) {
      return ok(null);
    }

    return SubscriptionValidator.Invoice.fromAPI(latestPaid);
  },
};

export { SubscriptionApiRepository };
